module.exports = __webpack_public_path__ + "img/qijian-card.fe099bf1.svg";